import React from 'react';
import PropTypes from 'prop-types';

import { journeyShape } from 'constants/propTypes';
import { INBOUND, OUTBOUND } from 'constants/booking';
import { Row } from 'components/shared/Layout';

import { splitLegsByDirection } from './SegmentSummary.utils';
import SegmentSummaryColumn from './SegmentSummaryColumn';

const SegmentSummary = ({
  currency,
  pendingCreationLegs,
  pendingCancellationLegs,
  trainMarginDeprecated,
  cancelledFirst = false,
  isMiceGroup = false
}) => {
  const [outboundCreationLegs, inboundCreationLegs] = splitLegsByDirection(pendingCreationLegs || []);

  const [outboundCancellationLegs, inboundCancellationLegs] = splitLegsByDirection(pendingCancellationLegs || []);

  const hasOldTickets = Boolean(pendingCancellationLegs.length);
  const hasNewTickets = Boolean(pendingCreationLegs.length);

  const sortByDepartureDate = (a, b) => new Date(a.timing.isoDate) - new Date(b.timing.isoDate);
  const sortedInboundCreationLegs = inboundCreationLegs.sort(sortByDepartureDate);
  const sortedOutboundCreationLegs = outboundCreationLegs.sort(sortByDepartureDate);
  const sortedInboundCancellationLegs = inboundCancellationLegs.sort(sortByDepartureDate);
  const sortedOutboundCancellationLegs = outboundCancellationLegs.sort(sortByDepartureDate);

  return (
    <Row>
      <SegmentSummaryColumn
        cancelledFirst={cancelledFirst}
        direction={OUTBOUND}
        currency={currency}
        pendingCancellationLegs={sortedOutboundCancellationLegs}
        pendingCreationLegs={sortedOutboundCreationLegs}
        trainMarginDeprecated={trainMarginDeprecated}
        hasOldTickets={hasOldTickets}
        hasNewTickets={hasNewTickets}
        isMiceGroup={isMiceGroup}
      />
      <SegmentSummaryColumn
        cancelledFirst={cancelledFirst}
        direction={INBOUND}
        currency={currency}
        pendingCancellationLegs={sortedInboundCancellationLegs}
        pendingCreationLegs={sortedInboundCreationLegs}
        trainMarginDeprecated={trainMarginDeprecated}
        hasOldTickets={hasOldTickets}
        hasNewTickets={hasNewTickets}
        isMiceGroup={isMiceGroup}
      />
    </Row>
  );
};

SegmentSummary.propTypes = {
  currency: PropTypes.string,
  pendingCreationLegs: journeyShape,
  pendingCancellationLegs: journeyShape,
  trainMarginDeprecated: PropTypes.number,
  cancelledFirst: PropTypes.bool,
  isMiceGroup: PropTypes.bool
};

export default SegmentSummary;
